import {PayloadAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'

import {http} from 'hiya-common/src/utils/axios'
import {TasksStatusEnum} from './constant'

// 【盲盒活动任务列表】http://wiki.xunlei.cn/pages/viewpage.action?pageId=138969778
export const get_blind_box_tasks = createAsyncThunk(
  '/live/gift/get_blind_box_tasks',
  async (p: any, store: any) => {
    const resp = await http.post<HiyaRes<{blind_box_list: Iblind_box_item[]}>>(
      '/live/gift/get_blind_box_tasks',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// 【盲盒活动榜单】http://wiki.xunlei.cn/pages/viewpage.action?pageId=138969851
export const get_blind_box_rank = createAsyncThunk(
  '/live/gift/get_blind_box_rank',
  async (p: any, store: any) => {
    const resp = await http.post<HiyaRes<RankResponse>>(
      '/live/gift/get_blind_box_rank',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// 【领取盲盒任务奖励】http://wiki.xunlei.cn/pages/viewpage.action?pageId=138969842
export const receive_box_task_reward = createAsyncThunk(
  '/live/gift/receive_box_task_reward',
  async (p: {task_id: number}, store: any) => {
    const resp = await http.post('/live/gift/receive_box_task_reward', {
      ...p,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export interface Iblind_box_item {
  box_name: string
  box_type: number //	盲盒类型 0-低级 1-高级
  gift_id: number // 礼物id
  task_list: Iblind_box_task[]
}

export interface Iblind_box_task {
  task_id: number
  task_icon_url: string
  task_name: string
  reward_txt: string
  task_required: number
  task_progress: number
  state: TasksStatusEnum
}

export interface RankResponse {
  own_rank: Irank_item // 用户自己的排行信息
  topn_prizes: Iprize_tab[] // 榜单前几名的奖励
}

export interface Irank_item {
  rank?: number
  mid: number
  avatar: string
  username: string
  lucky_val: number
  contribute_tops: Icontribute_item[] // 贡献榜top N
  own_contribute: number
}
export interface Icontribute_item {
  mid: number
  avatar: string
  username: string
  contribute_val: number // 我的贡献值
}

export interface Iprize_item {
  validity: number // 有效期，秒
  img_url: string // 图片url
  name: string // 奖品名字
  num: number // 数量
  worth: string // 奖品价值
}

export interface Iprize_tab {
  rank_tab: string // 排名范围	Top1-3
  prizes: Iprize_item[]
}

export interface InitialStateType {
  blind_box_list: Iblind_box_item[]
  own_rank?: Irank_item
  topn_prizes: Iprize_tab[]
  task_time?: string
  reward_time?: number // 奖励下发时间戳，秒
  activeGiftId: number
}

const initialState: InitialStateType = {
  blind_box_list: [],
  topn_prizes: [],
  activeGiftId: 0,
}

export const BlindBoxChallenge = createSlice({
  name: 'BlindBoxChallenge',
  initialState,
  reducers: {
    setActiveGiftId: (state, action: PayloadAction<{activeGiftId: number}>) => {
      Object.assign(state, action.payload)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_blind_box_tasks.fulfilled, (state, action) => {
      Object.assign(state, {
        blind_box_list: action.payload.blind_box_list || [],
      })
    })

    builder.addCase(get_blind_box_rank.fulfilled, (state, action) => {
      Object.assign(state, {...action.payload})
    })
  },
})

export const useBlindBoxChallenge = () =>
  useSelector((store) => store.BlindBoxChallenge)

export default BlindBoxChallenge.reducer
export const BlindBoxChallengeActions = BlindBoxChallenge.actions
